/* eslint-disable react-hooks/exhaustive-deps */
import { Callout } from "@blueprintjs/core"
import { useEffect } from "react"
import { ID } from "src/libs/interfaces/layouts"
import { __ } from "src/libs/utilities"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { ILanding } from "src/modules/pe-landing-module/data/interfaces"
import { schema } from "src/modules/pe-landing-module/data/schema"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { CompositeForm } from "src/modules/pe-landing-module/widgets/composite/CompositeForm"

/* Protopia Ecosystem component */
export interface ITitleProps {
   
}
const Title = (props: ITitleProps): JSX.Element => {
    const currentLanding:ILanding   = useLandingStore((state: ILandingStore) => state.currentLanding)    
    const selectedLayer : ID        = useLandingStore( (state:ILandingStore) => state.selectedLayer )    
    const value                     = useSyncState<any>(null)
        
    useEffect(() => {
        value.set( currentLanding.sections.find(section => section.id === selectedLayer )) 
    }, [ selectedLayer ])
    
    const isCollapsesOpen: boolean[] = []
    const onCollapsesOpen = () => {}
    const onChange = (_value: any, field: string, data: any) => {
        
        console.log(_value, field, data)
        
    } 
    const form: JSX.Element =  !!value.get() 
        ?
        <>
            <CompositeForm 
                schemaType={schema().Title.apollo_fields }
                origin={value.get()}
                value={value.get().title}
                onChange={onChange}
                schemaData={schema().Title}
                onCollapsesOpen={onCollapsesOpen}
                isCollapsesOpen={isCollapsesOpen}
            />
            {/* <CompositeForm 
                schemaType={schema().Description.apollo_fields }
                origin={value.get()}
                value={value.get().description}
                onChange={onChange}
                schemaData={schema().Description}
                onCollapsesOpen={onCollapsesOpen}
                isCollapsesOpen={isCollapsesOpen}
            /> */}
        </> 
        :
        <Callout className="p-5 m-2 letter-spacing-1">
            <div className="small">
                {__("No section selected")}
            </div>
            <div className="micro mt-2">
                {__("Select some section")}
            </div>
        </Callout>

    return <div className="landing-edit-layer"> 
        <div className="panel-list-2 overflow-y-auto"> 
            { form } 
        </div>
    </div>
}
export default Title